import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import styles from './Home.module.css'
import { Helmet } from 'react-helmet'

import Before1 from '../../assets/before1r.webp'
import Before2 from '../../assets/before2r.webp'
import Before3 from '../../assets/before3r.webp'
import Before4 from '../../assets/before4r.webp'
import Before5 from '../../assets/before5r.webp'
import Before6 from '../../assets/before6r.webp'
import Before7 from '../../assets/before7r.webp'
import Before8 from '../../assets/before8r.webp'
import Before9 from '../../assets/before9r.webp'
import Before10 from '../../assets/before10r.webp'
import Before11 from '../../assets/before11r.webp'
import After1 from '../../assets/after1.webp'
import After2 from '../../assets/after2.webp'
import After3 from '../../assets/after3.webp'
import After4 from '../../assets/after4.webp'
import After5 from '../../assets/after5.webp'
import After6 from '../../assets/after6.webp'
import After7 from '../../assets/after7.webp'
import After8 from '../../assets/after8.webp'
import After9 from '../../assets/after9.webp'
import After10 from '../../assets/after10.webp'


export default function Home() {
  const navigate = useNavigate()
  const [ currentImageAfterIndex, setCurrentImageAfterIndex ] = useState(0)
  const [ currentImageBeforeIndex, setCurrentImageBeforeIndex ] = useState(0)
  
  const carouselImagesBefore = [
    { src: Before1, alt: 'before a' },
    { src: Before2, alt: 'before b' },
    { src: Before3, alt: 'before c' },
    { src: Before4, alt: 'before d' },
    { src: Before5, alt: 'before e' },
    { src: Before6, alt: 'before f' },
    { src: Before7, alt: 'before g' },
    { src: Before8, alt: 'before h' },
    { src: Before9, alt: 'before i' },
    { src: Before10, alt: 'before j' },
    { src: Before11, alt: 'before k' },
  ]

  const carouselImagesAfter = [
    /*{ src: After1, alt: 'after a' },
    { src: After2, alt: 'after b' },
    { src: After3, alt: 'after c' },
    { src: After6, alt: 'after d' },*/
    { src: After7, alt: 'after e' },
    { src: After8, alt: 'after f' },
    { src: After9, alt: 'after g' },
    { src: After10, alt: 'after h' },
    /*{ src: After4, alt: 'after Crifty In the Woods' },
    { src: After5, alt: 'after Crifty In the Park' },*/
  ]
  const carouselIntervalBefore = 3000 //interval in ms
  const carouselIntervalAfter = 4000 //interval in ms

  useEffect(() => {
    const preloadLink = document.createElement('link')
    preloadLink.rel = 'preload'
    preloadLink.as = 'image'
    preloadLink.href = carouselImagesBefore[0].src // Preload the first image
    document.head.appendChild(preloadLink)
  }, [])

  useEffect(() => {
    const intervalAfter = setInterval(() => {
      setCurrentImageAfterIndex((prevIndex) => (prevIndex + 1) % carouselImagesAfter.length)
    }, carouselIntervalAfter)

    return () => clearInterval(intervalAfter)
  }, [])

  useEffect(() => {
    const intervalBefore = setInterval(() => {
      setCurrentImageBeforeIndex((prevIndex) => (prevIndex + 1) % carouselImagesBefore.length)
    }, carouselIntervalBefore)

    return () => clearInterval(intervalBefore)
  }, [])
    
  return (
    <div className={styles['main']}>
      <Helmet>
        <title>Crifty Bookkeeping - Simple Financial Management</title>
        {/*-- SEO Meta Tags --*/}
        <meta name="description" content="Simplify bookkeeping with Crifty. Manage invoices, track expenses, and access real-time insights as easy as 2+1." />
        <meta name="keywords" content="bookkeeping, finance, accounting, invoice generator, expense tracker" />
        <meta name="author" content="Crifty" />
        <link rel="canonical" href="https://crifty.com/home" />

        {/*-- Open Graph / Social Meta Tags (Improved) */}
        <meta property="og:title" content="Smart and Easy Bookkeeping for Small Businesses and Entrepreneurs" />
        <meta property="og:description" content="Crifty helps entrepreneurs and small businesses simplify bookkeeping. Generate invoices, track expenses, and get real-time financial insights—all in one intuitive dashboard." />
        <meta property="og:image" content="https://crifty.com/OG-crifty.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Crifty Bookkeeping Dashboard" />
        <meta property="og:url" content="https://crifty.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Crifty" />

        {/*-- Twitter Meta Tags --*/}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Crifty Easy Bookkeeping" />
        <meta name="twitter:description" content="Simplify bookkeeping with Crifty, your business finance companion." />
        <meta name="twitter:image" content="https://crifty.com/OG-crifty.webp" />
        <meta name="twitter:site" content="@CriftyApp" />


        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "Crifty Bookkeeping",
              "applicationCategory": "BusinessApplication",
              "operatingSystem": "Web",
              "description": "Simplify bookkeeping with Crifty. Manage invoices, track expenses, and access real-time insights.",
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Crifty",
                "url": "https://crifty.com"
              }
            }
          `}
      </script>

      </Helmet>
      {/*<div className={styles['horizontal-line']}></div>*/}
      <h1>Bookkeeping Software That Turns Chaos Into Clarity</h1>
      <h3>Crifty helps entrepreneurs and small businesses organize invoices, track expenses, and simplify accounting—without spreadsheets or stress.</h3>
      {/*<div className={styles['horizontal-line']}></div>*/}
      
      <div className={styles['introduction']}>
        {/** before images */}
        <img
          src={carouselImagesBefore[currentImageBeforeIndex].src}
          alt={carouselImagesBefore[currentImageBeforeIndex].alt}
          width={512}
          height={512}
          // Modern attributes:
          loading={currentImageBeforeIndex === 0 ? "eager" : "lazy"} // Eager load first image
          decoding="async" // Non-blocking image decode
          fetchpriority={currentImageBeforeIndex === 0 ? "high" : "auto"}
          className={styles['split-image']} 
        />
        {/* after images carousel */}
        <img
          src={carouselImagesAfter[currentImageAfterIndex].src}
          alt={carouselImagesAfter[currentImageAfterIndex].alt}
          width={512}
          height={512}
          // Modern attributes:
          loading={currentImageAfterIndex === 0 ? "eager" : "lazy"} // Eager load first image
          decoding="async" // Non-blocking image decode
          fetchpriority={currentImageBeforeIndex === 0 ? "high" : "auto"}
          className={styles['split-image']} 
        />
        <div className={styles['split-image-text']}>
          <div className={styles['box']}>
            {/*<div className={styles['horizontal-line']}></div>*/}
            <h2>Ready to leave the chaos behind?</h2>
            <h1 onClick={()=>navigate(`/subscriptionselection/`)} className={styles['work-together-click']}>See our plan</h1>
            <p>and</p>
            <h1 className={styles['work-together-click']} onClick={() => navigate('/signup')}>Join for free</h1>
            <p>14 days free trial. Cancel anytime at no cost.</p>
            {/*<div className={styles['horizontal-line']}></div>*/}
          </div>
        </div>  
      </div>




      <div className={styles['introduction']}>

        <div className='container-center'>
          <div className='split-noline'>
            <h1>Built for Founders Who Do It All</h1>
            <p className={styles['center']}>Whether you're juggling clients, chasing invoices, or prepping for tax season, Crifty gives you clarity and control. No accounting jargon. Just clean, intuitive tools that work the way you do.</p>
          </div>
          <div className='split-noline'>
            <div className='container-center'>
              <img 
                src={After4}
                alt='after bookkeeping'
                width={512}
                height={512}
                loading="lazy" 
                decoding="async"
                fetchpriority="auto"
                className={styles['split-image2']} 
              />
            </div>
          </div>
        </div>

        <div className='container-center'>
          <div className='split-noline'>
            <div className='container-center'>
              <img 
                src={After5}
                alt='after bookkeeping'
                width={512}
                height={512}
                loading="lazy" 
                decoding="async"
                fetchpriority="auto"
                className={styles['split-image2']} 
              />
            </div>
          </div>
          <div className='split-noline'>
            <h1>Smart Tools for Smarter Finances</h1>
            <ul className={styles['center']}>
          
              <li><h4>Real-time expense tracking and financial dashboard</h4></li>
              <li><h4>Secure cloud-based bookkeeping with automated backups</h4></li>
              <li><h4>Seamless PDF exports for receipts, reports, and tax filing</h4></li>
            </ul>
          </div>
        </div>

        <div className='container-center'>
          <div className='split-noline'>
            
            <h1 className={styles['work-together-click']} onClick={() => navigate('/signup')}>Join for free</h1>
            
          </div>
          <div className='split-noline'>
            <div className='container-center'>
              <img 
                src={After6}
                alt='after bookkeeping'
                width={512}
                height={512}
                loading="lazy" 
                decoding="async"
                fetchpriority="auto"
                className={styles['split-image2']} 
              />
            </div>            
          </div>
        </div>
      </div>


      <div className={styles['testimonials-col']}>
        <h1>Testimonials</h1>

        <div className={styles['testimonials']}>        
          <div className={styles['testimonial-box5']}>
            <p className={styles['center']}><b><i>"Crifty turned our financial fog into a crystal-clear dashboard."</i></b></p>
            <p className={styles['center']}> - Freelance Consultant</p>
          </div>
          <div className={styles['testimonial-box1']}>
            <p className={styles['center']}><b><i>"Before Crifty, we are chasing spreadsheets. Now we are chasing growth."</i></b></p>
            <p className={styles['center']}> - Operations Lead, Retail</p>
          </div>
          <div className={styles['testimonial-box2']}>
            <p className={styles['center']}><b><i>"Before Crifty, it was confusion. Now it's control."</i></b></p>
            <p className={styles['center']}> - Logistics Manager</p>
          </div>
          <div className={styles['testimonial-box3']}>
            <p className={styles['center']}><b><i>“Crifty gave us clarity across departments. It’s not just bookkeeping—it’s operational sanity.”</i></b></p>
            <p className={styles['center']}> - Finance Manager</p>
          </div>
          <div className={styles['testimonial-box']}>
            <p className={styles['center']}><b><i>“I had a product, a dream, and zero systems. Crifty didn’t just organize my books—it gave me a roadmap.”</i></b></p>
            <p className={styles['center']}> - Startup Founder</p>
          </div>
          <div className={styles['testimonial-box5']}>
            <p className={styles['center']}><b><i>“We were drowning in receipts and missed deadlines. Crifty turned our chaos into clean dashboards and growth.”</i></b></p>
            <p className={styles['center']}> - Retail Owner</p>
          </div>
          <div className={styles['testimonial-box2']}>
            <p className={styles['center']}><b><i>"We used to miss deliveries. Now we anticipate them."</i></b></p>
            <p className={styles['center']}> - Operations Manager</p>
          </div>
          
        </div>
        <br></br>
        <br></br>
        <h1 className={styles['work-together-click']} onClick={() => navigate('/signup')}>Join for free</h1>
        

      </div>
      
      

      
      
    </div>
  )
}